import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { CardHeader } from 'modules/core/components/OldCard'

import type ClockPicture from 'modules/employees/store/models/ClockPicture'

import InfoForm from './InfoForm'

interface Props {
  clockPicture: ClockPicture
  employeeFullName: string
  onClose: () => void
}

const PictureInfo = ({ clockPicture, employeeFullName, onClose }: Props) => {
  return (
    <Box overflowY="auto" overflowX="auto" height="full">
      <CardHeader
        middle={<Text.Header2>{clockPicture.attributes.filename}</Text.Header2>}
        right={<Button onClick={onClose} type="secondary" iconName="cross" />}
      />
      <InfoForm clockPicture={clockPicture} employeeFullName={employeeFullName} />
    </Box>
  )
}

export default observer(PictureInfo)
